import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(
  Vuetify, {
    theme: {
      // iconfont:'md',
      primary: '#01579B',
      primaryDark: '#0277BD',
    }
  })
